<template>
  <button>SFC Button</button>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  name: "SFCButton",
});
</script>
